import { UseQueryOptions } from '@tanstack/react-query';
import {
	HubSpotGetObjectDetailsPayload,
	HubSpotGetObjectDetailsResult,
	HubSpotObjectType,
	hubSpotPrefix,
	urlCombine,
} from 'ihub/common';
import {
	getTenantID,
	microServiceAPI,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class HubSpotHttpService {
	private getObjectTypesPath = 'GetObjectTypes';
	private getObjectStructurePath = 'GetObjectStructure';

	getObjectTypesQuery(
		payload: HubSpotGetObjectDetailsPayload
	): UseQueryOptions<HubSpotObjectType[], Error, HubSpotObjectType[]> {
		return {
			queryKey: [getTenantID(), hubSpotPrefix, this.getObjectTypesPath, payload.accessToken],
			queryFn: async (): Promise<HubSpotObjectType[]> => {
				const url = urlCombine(microServiceAPI, hubSpotPrefix, this.getObjectTypesPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(
					res,
					'Get HubSpot object types',
					HubSpotGetObjectDetailsResult.name
				);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getObjectStructureQuery(
		payload: HubSpotGetObjectDetailsPayload
	): UseQueryOptions<HubSpotGetObjectDetailsResult, Error, HubSpotGetObjectDetailsResult> {
		return {
			queryKey: [
				getTenantID(),
				hubSpotPrefix,
				this.getObjectStructurePath,
				payload.accessToken,
				payload.hubSpotObjectType,
			],
			queryFn: async (): Promise<HubSpotGetObjectDetailsResult> => {
				const url = urlCombine(microServiceAPI, hubSpotPrefix, this.getObjectStructurePath);
				const res = await standardPost(url, payload);
				await validateOkResponse(
					res,
					'Get HubSpot object schema',
					HubSpotGetObjectDetailsResult.name
				);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
